<ul class="nav nav-tabs d-flex align-items-center" id="ExamReportEditTab" role="tablist">
  <li class="nav-item" role="presentation">
    <a
      class="nav-link exam-report-tab no-navigation"
      [ngClass]="{ active: activeTab === 'exam-report-details' }"
      (click)="changeTab('exam-report-details')"
      [routerLink]="activeTab !== 'exam-report-details' ? ['exam-report-details']: []"
    >
      Jegyzőkönyv adatai
    </a>
  </li>
  <li class="nav-item" role="presentation">
    <a
      class="nav-link exam-report-tab no-navigation"
      [ngClass]="{ active: activeTab === 'examiners' }"
      (click)="changeTab('examiners')"
      [routerLink]="activeTab !== 'examiners' ? ['examiners']: []"
    >
      Vizsgabiztosok
    </a>
  </li>
  <li class="nav-item" role="presentation">
    <a
      class="nav-link exam-report-tab no-navigation"
      [ngClass]="{ active: activeTab === 'students' }"
      (click)="changeTab('students')"
      [routerLink]="activeTab !== 'students' ? ['students']: []"
    >
      Vizsgázók
    </a>
  </li>
  <li class="nav-item" role="presentation">
    <a
      class="nav-link exam-report-tab no-navigation"
      [ngClass]="{ active: activeTab === 'results' }"
      (click)="changeTab('results')"
      [routerLink]="activeTab !== 'results' ? ['results']: []"
    >
      Eredmények
    </a>
  </li>
  <li class="ms-auto">
    <p *ngIf="syncInfo" class="p-3 pb-0 mb-0 fw-light d-flex text-black-50">{{ syncInfo }}</p>
  </li>
  <li class="ml-1">
    <button
      (click)="sync()"
      [disabled]="!canSync"
      type="button"
      title="Szinkronizálás"
      id="sync-button"
      class="btn btn-primary text-white d-flex"
    >
      <span class="material-icons-outlined">sync_alt</span>
    </button>
  </li>
</ul>

<router-outlet></router-outlet>
